import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  KeyweeFeedFacebookPostsQuery,
  KeyweeFeedFacebookPostsQueryVariables
} from './__generated__/KeyweeFeedFacebookPostsQuery';

export const KEYWEE_FEED_FACEBOOK_POSTS_QUERY = gql`
  query KeyweeFeedFacebookPostsQuery($params: KeyweeFeedFacebookPostsInput!, $campaignId: ID!) {
    keyweeFeedFacebookPosts(params: $params, campaignId: $campaignId) {
      articles {
        url
        publishedAt
        facebookPosts {
          externalId
        }
      }
      error
    }
  }
`;

export const useKeyweeFeedFacebookPostsLazyQuery = () => {
  return useLazyQuery<KeyweeFeedFacebookPostsQuery, KeyweeFeedFacebookPostsQueryVariables>(
    KEYWEE_FEED_FACEBOOK_POSTS_QUERY,
    {
      client: kmsClient,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true
    }
  );
};
